module.exports = __webpack_public_path__ + "static/media/ft2-monsoon.5e32966e.png";